import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';
import { URL } from '../../constants/urls.constants';

/**
 * User engagement metrics – session end.
 * Calls POST /avtopia/api/v1/user/session/end (UserAuth).
 * Use on logout and optionally when app goes to background.
 */
@Injectable({
  providedIn: 'root'
})
export class UserSessionService {

  constructor(private $http: HttpService) {}

  /**
   * End the current user session (no request body).
   * Does not show loader. Call on logout or when app goes to background.
   */
  endSession(): Observable<unknown> {
    return this.$http.post(URL.userSessionEnd, {}, {}, false);
  }
}
